import RPLogo from "src/images/RP-GE.svg";
import {
  LogoContainer,
  LogoContainerInner,
  paraStyle,
} from "./EmptyLandingPage.css";
import { Typography } from "@progress/kendo-react-common";

const EmptyLandingPage = () => {
  return (
    <div className={LogoContainer}>
      <div className={LogoContainerInner}>
        <img src={RPLogo} alt="Retail Pricing Logo" />
      </div>
      <Typography.p className={paraStyle}>Retail Pricing</Typography.p>
    </div>
  );
};

export default EmptyLandingPage;
